import React from "react";
import "../styles/StatCardFour.css";

const StatCardFour = () => {
    return (
        <div className="stat-card-four">
            <p className="stat-number">6+</p>
            <p className="stat-text">Years of <br />Dedicated <br /> Service</p>
        </div>
    );
};

export default StatCardFour;
